import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {FeedToolPanelComponent} from '../components/feed-tool-panel/feed-tool-panel.component';
import {
  ColDef,
  GetContextMenuItemsParams, GetRowIdFunc, GetRowIdParams,
  GridReadyEvent,
  IServerSideGetRowsParams, ProcessCellForExportParams,
  RowClassRules, RowModelType
} from 'ag-grid-community';
import { SharedService } from 'src/app/services/shared.service';
import {AgGridAngular} from 'ag-grid-angular';
import {GridService} from '../../services/grid.service';
import {HttpService} from '../../services/http.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {HistoryDialogComponent} from '../dialogs/history-dialog/history-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import {shareReplay} from 'rxjs/operators';
import {AdminToolPanelComponent} from '../components/admin-tool-panel/admin-tool-panel.component';

@Component({
  selector: 'app-grid-production',
  templateUrl: './grid-production.component.html',
  styleUrls: ['./grid-production.component.scss']
})
export class GridProductionComponent implements OnInit, OnDestroy {
  public user$: Observable<any>;
  public readonly rowModelType: RowModelType = 'serverSide';
  public readonly paginationPageSize = 1000;
  public readonly cacheBlockSize = 300;
  public readonly maxBlocksInCache = this.cacheBlockSize / 3;
  public readonly maxConcurrentDatasourceRequests = 1;
  public readonly rowGroupPanelShow = 'never';
  public readonly pivotPanelShow = 'always';
  public readonly rowSelection = 'multiple';
  public readonly overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait...</span>';
  private gridReady: boolean = false;
  public readonly sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
        }
      },
      // https://www.ag-grid.com/angular-data-grid/component-tool-panel/
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      },
      // {
      //   id: 'feedsPanel',
      //   labelDefault: 'Feeds',
      //   labelKey: 'customStats',
      //   iconKey: 'pivotPanel',
      //   toolPanel: FeedToolPanelComponent,
      // },
    ],
  };
  public pinnedTopRowData: any[] = [];
  public readonly autoGroupColumnDef: ColDef = {
    minWidth: 200,
  }
  public getRowId: GetRowIdFunc = (params: GetRowIdParams) => {
    // console.log('params.data._id', params.data);
    return params.data._id;
  };
  public rowClassRules: RowClassRules = {
    'not-valid': (params) => {
      if (params.data && (!params.data.handle || !params.data.brand)) {
        return true
      } else {
        return false;
      }
    },
    'sync-in-progress': (params) => {
      if (params.data) {
        return params.data.status === 70;
      } else {
        return false;
      }
    },
    // 'import-product': (params) => {
    //   return !!(params.data && params.data.new);
    // },
    'sync-in-pending': (params) => {
      if (params.data) {
        return params.data.status === 60;
      } else {
        return false;
      }
    },
    'deleted': (params) => {
      if (params.data) {
        return !!params.data.successfullyDeleted;
      } else {
        return false;
      }
    },
    'product-change-icon' : (params) => {
      // return !!(params.data && [20].includes(params.data.status) && !params.data.new);
      return !!(params.data && [20].includes(params.data.status));
    },
    'sync-error': (params) => {
      if (params.data) {
        return params.data.status === 80;
      } else {
        return false;
      }
    },
  };
  public readonly statusBar = {
    statusPanels: [
      { statusPanel: 'agSelectedRowCountComponent' }
    ],
  };

  public columnDefs: ColDef[] = this.sharedService.columnDefs;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    sortable: true,
    editable: false,
    filter: true,
    resizable: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset'],
    },

    cellClass: (params: any) => {
      const cellChanged = params.data?.fields_status?.[params.colDef.field] === 20;
      const cellLock = params.data.locked !== undefined && Object.keys(params.data.locked).length > 0;
      const cellLockOtherUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id !== this.authService.currentUserValue?._id: false;
      const cellLockCurrentUsers = cellLock ? params.data.locked && params.data.locked.user && params.data.locked.user._id === this.authService.currentUserValue._id: false;
      const cellPrice = (params.colDef.field === 'list_price' || params.colDef.field === 'cost_price'  || params.colDef.field === 'sell_price' || params.colDef.field === 'mws_sell_price');

      // if (cellPrice && cellChanged && params.data.new !== true) {
      if (cellPrice && cellChanged) {
        return ['number-cell', 'ag-cell-changed'];
      // } else if (cellChanged && params.data.new !== true) {
      } else if (cellChanged) {
        return 'ag-cell-changed';
      } else if (params.colDef.field === 'sku') {
        return 'sku-col';
      } else if (cellPrice) {
        return 'number-cell';
      }

      return '';
    }
  };
  public rowData$!: Observable<any[]>;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(
    private sharedService: SharedService,
    private gridService: GridService,
    private httpService: HttpService,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
    private authService: AuthService,
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );
  }

  ngOnDestroy() {
    this.gridService.productionSelectedItemsCount$.next(0);
  }

  ngOnInit(): void {
    this.user$.subscribe(res => {
      // if (res && res.access.level === 1) {
      //   const toolPanel: any = {
      //     id: 'adminPanel',
      //     labelDefault: 'Admin',
      //     labelKey: 'customStats',
      //     iconKey: 'columnMoveMove',
      //     toolPanel: AdminToolPanelComponent,
      //     width: 400,
      //     maxWidth: 400,
      //   }
      //
      //   this.sideBar.toolPanels.push(toolPanel);
      //   setTimeout(() => {
      //     this.gridService.productionGridApi?.refreshToolPanel();
      //     this.gridService.productionGridApi?.setSideBar(this.sideBar);
      //   }, 500);
      // }
    });
    const confirmationRow = this.columnDefs.find(x => x.field === 'confirm');
    const changeByUserRow = this.columnDefs.find(x => x.field === 'changed_by');
    const pushedAtRow = this.columnDefs.find(x => x.field === 'pushed_at');
    const pushedUserRow = this.columnDefs.find(x => x.field === 'pushed_user');
    const skuRow = this.columnDefs.find(x => x.field === 'sku');
    const updatedAtRow = this.columnDefs.find(x => x.field === 'updated_at');
    const statusRow = this.columnDefs.find(x => x.field === 'status');

    if (statusRow) {
      statusRow.hide = false;
    }

    if (updatedAtRow) {
      updatedAtRow.hide = true;
      updatedAtRow.sortable = false;
      updatedAtRow.sort = null;
      updatedAtRow.suppressFiltersToolPanel = true;
      updatedAtRow.suppressColumnsToolPanel = true;
    }

    if (changeByUserRow) {
      changeByUserRow.hide = true;
      changeByUserRow.sortable = false;
      changeByUserRow.suppressFiltersToolPanel = true;
      changeByUserRow.suppressColumnsToolPanel = true;
    }

    if (skuRow) {
      skuRow.pinned = 'left';
      skuRow.sort = 'asc';
      skuRow.checkboxSelection = true;
    }

    if (confirmationRow) {
      confirmationRow.hide = true;
      confirmationRow.suppressFiltersToolPanel = true;
      confirmationRow.suppressColumnsToolPanel = true;
    }
    if (pushedAtRow) {
      pushedAtRow.hide = true;
      pushedAtRow.suppressFiltersToolPanel = true;
      pushedAtRow.suppressColumnsToolPanel = true;
      pushedAtRow.sort = null;
    }
    if (pushedUserRow) {
      pushedUserRow.hide = true;
      pushedUserRow.suppressFiltersToolPanel = true;
      pushedUserRow.suppressColumnsToolPanel = true;
    }
  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    let restoreValue: any = null;
    const cellId: any = params.column?.getId();
    const disableHistoryBtn = params.node?.data.logs[cellId] === false;
    return [
      {
        name: 'Open BHS Shopify Page',
        disabled: environment.staging === true ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      {
        name: 'Open BHS Shopify Admin Page',
        disabled: environment.staging === true ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://admin.shopify.com/store/bhawk/products/' + params?.node?.data.shopify_id.replace('gid://shopify/Product/', ''), '_blank');
        }
      },
      'separator',
      {
        name: 'Open MWS Shopify Page',
        disabled: environment.staging === true ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://midwestsupplyus.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      {
        name: 'Open MWS Shopify Admin Page',
        disabled: environment.staging === true ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://admin.shopify.com/store/midwest-supply-us/products/' + params?.node?.data.mws_shopify_id.replace('gid://shopify/Product/', ''), '_blank');
        }
      },
        'separator',
        {
          name: 'Open Both Shopify Pages',
          disabled: environment.staging === true ? true : false,
          icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
          action: () => {
            window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
            window.open('https://midwestsupplyus.com/products/' + params?.node?.data.handle, '_blank');
          }
        },
      'separator',
      {
        name: 'Open <b>STAGE</b> Shopify Page',
        disabled: environment.staging === false ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://bhawk1.myshopify.com/products/' + params?.node?.data.handle, '_blank');
        }
      },
      {
        name: 'Open <b>STAGE</b> Admin Page',
        disabled: environment.staging === false ? true : false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://admin.shopify.com/store/bhawk1/products/' + params?.node?.data.shopify_id.replace('gid://shopify/Product/', ''), '_blank');
        }
      },
      'separator',
      {
        name: 'Auto Size Column',
        icon: '<span class="ag-icon ag-icon-maximize" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.productionColumnApi?.autoSizeColumn(colId);
        }
      },
      {
        name: 'Pin Row',
        icon: '<span class="ag-icon ag-icon-pin" unselectable="on" role="presentation"></span>',
        action: () => {
          const colId: any = params.column?.getId();
          this.gridService.productionGridApi?.setPinnedTopRowData([params?.node?.data]);
        }
      },
      {
        name: 'History',
        icon: '<span class="ag-icon ag-icon-group" unselectable="on" role="presentation"></span>',
        disabled: disableHistoryBtn,
        action: () => {
          console.log('params', params);
          this.dialog.open(HistoryDialogComponent, {
            width: '90%',
            maxWidth: '1024px',
            disableClose: true,
            data: {
              params,
              disableRollBack: true,
              sku: params.node?.data.sku,
              column: params.column?.getColDef().headerName,
              product_id: params.node?.data._id,
              field: params.column?.getId()
            }
          });
        }
      },
      restoreValue,
    ];
  }

  filterChanged($event: any): void {
    const filterModel = this.gridService.productionGridApi?.getFilterModel();
    this.localStorageService.setItem('productionFilterModel', filterModel);
    this.gridService.productionFilterIsActive$.next(!!(filterModel && Object.keys(filterModel).length));
  }

  onSelectionChanged(): void {
    const selectedRows: any = this.gridService.productionGridApi?.getSelectedRows();
    this.gridService.productionSelectedItemsCount$.next(selectedRows.length);
    console.log('🤲 selectedRows', selectedRows);
  }

  columnEverythingChanged($event: any): void {
    if (this.gridReady) {
      const savedState = this.gridService.productionColumnApi?.getColumnState();
      this.localStorageService.setItem('productionColumnState', savedState);
    }
  }

  processCellForClipboard(params: ProcessCellForExportParams) {
    const column = params.column.getId();
    if (['brand', 'type', 'shipping_tag'].includes(column)) {
      return params.value.name;
    } else if (column === 'datasheet_new') {
      return params.value.map((x: any) => x.url).join(', ');
    } else if (['tags', 'vendor_tags'].includes(column)) {
      return params.value.map((tag: any) => tag.name).join(', ');
    } else if (column === 'related_products' || column === 'related_parts') {
      return params.value.map((t: any) => t.product_id).join(', ');
    } else {
      return params.value;
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridService.productionGridApi = params.api;
    this.gridService.productionColumnApi = params.columnApi;
    const columnState = this.localStorageService.getItem('productionColumnState');
    // Strip saved sorts on array-valued columns — they are no longer
    // sortable, but a previously saved sort would still be applied by
    // applyColumnState and re-trigger the 10s server-side array sort.
    const unsortableCols = ['collections', 'related_products', 'related_parts', 'related_collections', 'tags', 'vendor_tags', 'asm_tags'];
    if (Array.isArray(columnState)) {
      for (const col of columnState) {
        if (unsortableCols.includes(col.colId)) { col.sort = null; }
      }
    }
    params.columnApi?.applyColumnState({
      state: columnState,
      applyOrder: true
    });
    const that = this;
    setTimeout(() => {
      const prevFilterModel = this.localStorageService.getItem('productionFilterModel');
      if (prevFilterModel) {
        this.gridService.productionGridApi?.setFilterModel(prevFilterModel);
      }
    }, 10);

    this.gridService.productionGridApi.setServerSideDatasource({
      getRows(params: IServerSideGetRowsParams) {
        const {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel} = params.request;

        const body = {startRow, endRow, rowGroupCols, groupKeys, filterModel, sortModel};
        that.httpService.post(environment.API_PATH + '/product/production', body).subscribe({
          next: (dataAndCount) => {
            const receivedData = dataAndCount as { rows: {}[], count: number };
            that.gridReady = true;
            params.success({
              rowData: receivedData.rows,
              rowCount: receivedData.count
            });
          },
          error: (err) => {
            console.error('Failed to load production data:', err);
            params.fail();
          }
        });
      }
    });
  }
}
